
import lang from '@/lang'
import OMOLogo from '@assets/images/logo/svg/logo.svg'
import CompanyData from './companyData-step'
import BankingData from './banking-step'
import LayoutData from './layout-step'
import LogoData from './logo-step'
import TaxSettingsData from './taxSettings-step'
import { ComponentType, SVGProps } from 'react'
import CompanyDataLogo from '@assets/images/onboarding/afterOnboardingIcon.svg?url'
import TaxSettingsLogo from '@assets/images/onboarding/testerOnboardingTaxSettings.svg?url'
import SettingsLogo from '@assets/images/onboarding/testerOnboardingLogo.svg?url'
import LayoutLogo from '@assets/images/onboarding/testerOnboardingLayout.svg?url'
import BankingLogo from '@assets/images/onboarding/testerOnboardingBanking.svg?url'

interface StepHeader {
  logo?: ComponentType<SVGProps<SVGSVGElement>>;
  title?: string;
  subTitle?: string;
  subTitle2?: string;
}

interface StepDefinition {
  component: React.ComponentType<RefAttributes<unknown>>;
  header: StepHeader;
  modalLogo?: string;
  trackingLabel?: string;
}

const steps: StepDefinition[] = [
  {
    component: CompanyData,
    header: {
      logo: OMOLogo,
      title: lang.onboardingTesterData.steps.title,
      subTitle: lang.onboardingTesterData.steps.subTitle,
      subTitle2: lang.onboardingTesterData.steps.subTitle2,
    },
    trackingLabel: 'Firmendaten vervollständigen',
    modalLogo: CompanyDataLogo,
  },
  {
    component: BankingData,
    header: {
      logo: OMOLogo,
      title: lang.onboardingTesterData.steps.banking.title,
      subTitle: lang.onboardingTesterData.steps.banking.subTitle,
      subTitle2: lang.onboardingTesterData.steps.banking.subTitle2,
    },
    trackingLabel: 'Fußzeile einfügen',
    modalLogo: BankingLogo,
  },
  {
    component: LogoData,
    header: {
      logo: OMOLogo,
      title: lang.onboardingTesterData.steps.logo.title,
      subTitle: lang.onboardingTesterData.steps.logo.subTitle,
      subTitle2: '',
    },
    trackingLabel: 'Logo hochladen',
    modalLogo: SettingsLogo,
  },
  {
    component: LayoutData,
    header: {
      logo: OMOLogo,
      title: lang.onboardingTesterData.steps.layout.title,
      subTitle: lang.onboardingTesterData.steps.layout.subTitle,
      subTitle2: lang.onboardingTesterData.steps.layout.subTitle2,
    },
    trackingLabel: 'Layout auswählen',
    modalLogo: LayoutLogo,
  },
  {
    component: TaxSettingsData,
    header: {
      logo: OMOLogo,
      title: lang.onboardingTesterData.steps.taxSettings.title,
      subTitle: lang.onboardingTesterData.steps.taxSettings.subTitle,
      subTitle2: lang.onboardingTesterData.steps.taxSettings.subTitle2,
    },
    trackingLabel: 'Logo USt ausweisen',
    modalLogo: TaxSettingsLogo,
  },
]

export default steps
